export default __webpack_public_path__ + "static/video-wiz-4-a8b8fe56a6a04d2d2dafca0958f02aa8.mp4";